import React from 'react';
import { isFeatureLaunched } from './isFeatureLaunched';
import { FeatureLaunch } from './featureLaunchEnum';

export const FeatureToggle = ({
  launch,
  companyId,
  children,
}: {
  launch: FeatureLaunch;
  companyId?: number;
  children: React.ReactElement;
}) => {
  return isFeatureLaunched(launch, companyId) ? children : null;
};
